import React from 'react';
import { Link } from 'react-router-dom';
import { WhiteSpace } from 'components/text';
import { RESET_PASSWORD } from 'constants/routes';
const EnterExistingPasswordErrorContent = () => (React.createElement(React.Fragment, null,
    "A password is already associated with this email address. In order to proceed, please enter that password.",
    React.createElement(WhiteSpace, null),
    React.createElement(Link, { className: "font-color--primary semibold", to: RESET_PASSWORD }, "Forgot your password?")));
export default EnterExistingPasswordErrorContent;
